var _circle, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon14(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 18.5,
    fill: "white",
    stroke: "#21A6E9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5833 19C26.1147 19 28.1667 21.052 28.1667 23.5833C28.1667 26.1147 26.1147 28.1667 23.5833 28.1667C21.052 28.1667 19 26.1147 19 23.5833C19 21.052 21.052 19 23.5833 19ZM25.7887 21.622L22.3784 25.0323L21.4167 23.75C21.2786 23.5659 21.0174 23.5286 20.8333 23.6667C20.6492 23.8047 20.6119 24.0659 20.75 24.25L22 25.9167C22.1522 26.1195 22.4487 26.1406 22.628 25.9612L26.378 22.2112C26.5407 22.0486 26.5407 21.7848 26.378 21.622C26.2152 21.4593 25.9514 21.4593 25.7887 21.622Z",
    fill: "#21A6E9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1837 23.1666H11.293L11.2082 23.1723C10.9031 23.2137 10.668 23.4752 10.668 23.7916C10.668 24.1368 10.9478 24.4166 11.293 24.4166H18.2316C18.1897 24.145 18.168 23.8667 18.168 23.5833C18.168 23.4431 18.1733 23.3041 18.1837 23.1666Z",
    fill: "#21A6E9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7781 21.0834H11.293C10.9478 21.0834 10.668 20.8035 10.668 20.4584C10.668 20.142 10.9031 19.8805 11.2082 19.839L11.293 19.8334H19.676C19.3206 20.2036 19.0175 20.6242 18.7781 21.0834Z",
    fill: "#21A6E9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7096 16.5H11.293L11.2082 16.5057C10.9031 16.5471 10.668 16.8086 10.668 17.125C10.668 17.4702 10.9478 17.75 11.293 17.75H26.7096L26.7945 17.7443C27.0995 17.7029 27.3346 17.4414 27.3346 17.125C27.3346 16.7798 27.0548 16.5 26.7096 16.5Z",
    fill: "#21A6E9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7096 13.1666H11.293L11.2082 13.1723C10.9031 13.2137 10.668 13.4752 10.668 13.7916C10.668 14.1368 10.9478 14.4166 11.293 14.4166H26.7096L26.7945 14.4109C27.0995 14.3695 27.3346 14.108 27.3346 13.7916C27.3346 13.4465 27.0548 13.1666 26.7096 13.1666Z",
    fill: "#21A6E9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon14);
export default __webpack_public_path__ + "static/media/icon14.0f84e0db264fecd92cf1e32629047baa.svg";
export { ForwardRef as ReactComponent };